import {Component, computed, inject, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tag} from 'primeng/tag';
import {Tooltip} from 'primeng/tooltip';
import {TemplateSuggestionStore} from '../template-suggestion.store';
import {
  CONFIDENCE_SEVERITY,
  SUGGESTION_KEY_PREFIX,
  SuggestionTagSeverity,
} from '../template-suggestion.types';

@Component({
  selector: 'app-suggestion-status-tag',
  imports: [TranslocoPipe, Tag, Tooltip],
  templateUrl: './suggestion-status-tag.component.html',
})
export class SuggestionStatusTagComponent {
  private readonly store = inject(TemplateSuggestionStore);

  readonly attributeDirectusId = input.required<string>();

  private readonly openSuggestion = computed(() =>
    this.store.openSuggestionFor(this.attributeDirectusId()),
  );
  protected readonly confidenceKey = computed(() => {
    const suggestion = this.openSuggestion();
    return suggestion ? `${SUGGESTION_KEY_PREFIX}.confidence.${suggestion.confidence}` : null;
  });
  protected readonly confidenceSeverity = computed<SuggestionTagSeverity>(() => {
    const suggestion = this.openSuggestion();
    return suggestion ? CONFIDENCE_SEVERITY[suggestion.confidence] : 'info';
  });
  protected readonly reviewRequired = computed(
    () => this.store.reviewRequiredSuggestionFor(this.attributeDirectusId()) !== undefined,
  );
  protected readonly clarification = computed(() =>
    this.store.clarificationFor(this.attributeDirectusId()),
  );
  protected readonly clarificationNote = computed(() => this.clarification()?.note ?? '');
}
